import React from 'react'

interface ProductCardSkeletonProps {
	className?: string
	viewMode?: 'grid' | 'list'
}

const ProductCardSkeleton: React.FC<ProductCardSkeletonProps> = ({
	className = '',
}) => {
	return (
		<div
			className={`bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm animate-pulse ${className}`}
		>
			<div className='flex flex-col md:flex-row'>
				<div className='relative w-full md:w-48 lg:w-56 aspect-square md:aspect-auto bg-gray-200'>
					<div className='w-full h-full bg-gradient-to-br from-gray-200 to-gray-300'></div>

					<div className='absolute top-2 left-2 flex flex-col gap-1'>
						<div className='bg-gray-300 rounded-md w-12 h-6'></div>
						<div className='bg-gray-300 rounded-md w-16 h-6'></div>
					</div>

					<div className='absolute top-2 right-2 bg-gray-300 rounded-md w-20 h-6'></div>
				</div>

				<div className='flex-1 p-4 space-y-3'>
					<div className='space-y-1'>
						<div className='flex items-start justify-between gap-2'>
							<div className='flex-1 min-w-0 space-y-2'>
								<div className='bg-gray-200 rounded w-20 h-3'></div>

								<div className='space-y-1'>
									<div className='bg-gray-300 rounded w-full h-4'></div>
									<div className='bg-gray-300 rounded w-3/4 h-4'></div>
								</div>
							</div>

							<div className='flex items-center gap-1 shrink-0'>
								<div className='bg-gray-200 rounded w-3 h-3'></div>
								<div className='bg-gray-200 rounded w-8 h-3'></div>
							</div>
						</div>
					</div>

					<div className='space-y-2'>
						<div className='flex items-center gap-2 flex-wrap'>
							<div className='w-10 h-10 rounded-full bg-gray-200'></div>
							<div className='w-10 h-10 rounded-full bg-gray-200'></div>
							<div className='w-10 h-10 rounded-full bg-gray-200'></div>

							<div className='bg-gray-200 rounded w-8 h-6'></div>
						</div>
					</div>

					<div className='space-y-2 pt-2 border-t border-gray-100'>
						<div className='flex items-baseline gap-2'>
							<div className='bg-gray-200 rounded w-16 h-4'></div>
							<div className='bg-gray-300 rounded w-24 h-6'></div>
							<div className='bg-gray-200 rounded w-20 h-4'></div>
						</div>

						<div className='flex items-center justify-between text-xs'>
							<div className='flex items-center gap-1'>
								<div className='w-3 h-3 bg-gray-200 rounded'></div>
								<div className='bg-gray-200 rounded w-20 h-3'></div>
							</div>

							<div className='flex items-center gap-1'>
								<div className='w-2 h-2 rounded-full bg-gray-200'></div>
								<div className='bg-gray-200 rounded w-12 h-3'></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

interface ProductCardSkeletonsProps {
	count?: number
	viewMode?: 'grid' | 'list'
}

const ProductCardSkeletons: React.FC<ProductCardSkeletonsProps> = ({
	count = 6,
	viewMode = 'list',
}) => {
	return (
		<div
			className={`${
				viewMode === 'grid'
					? 'grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6'
					: 'space-y-4'
			}`}
		>
			{Array.from({ length: count }).map((_, index) => (
				<ProductCardSkeleton
					key={index}
					viewMode={viewMode}
					className={viewMode === 'grid' ? 'h-full' : ''}
				/>
			))}
		</div>
	)
}

export { ProductCardSkeleton, ProductCardSkeletons }
